<ng-wizard [config]="config" (stepChanged)="stepChanged($event)">

  <ng-wizard-step [title]="'Step 1'" [description]="'Name'" [canEnter]="isValidTypeBoolean" [state]="stepState"
    [canExit]="isValidFunctionReturnsObservable.bind(this)">

    <h3>Name</h3>
    <app-connname></app-connname>
  </ng-wizard-step>

  <ng-wizard-step [title]="'Step 2'" [description]="'Trigger'" [canExit]="isValidFunctionReturnsObservable2.bind(this)" [state]="stepState"> 

    <h3>Trigger</h3>
    <app-conntrigger [RefereshToken]="refereshTokenTrigger"></app-conntrigger>

  </ng-wizard-step>

  <ng-wizard-step [title]="'Step 3'" [description]="'Action'" [canExit]="isValidFunctionReturnsObservable3.bind(this)">


    <h3>Action</h3>
    <app-connaction [RefereshToken]="refereshTokenAction"></app-connaction>
  </ng-wizard-step>
  <ng-wizard-step [title]="'Step 4'" [description]="'Summery'" [state]="stepStates.normal">

    <app-automationsummery></app-automationsummery>
  </ng-wizard-step>


  <!--  <ng-wizard-step [title]="'Step 5'" [description]="'Step 5 description'" [state]="stepStates.normal">
    <span>Step 5 content</span>
  </ng-wizard-step>

  <ng-wizard-step [title]="'Step 6'" [description]="'Step 6 description'" [state]="stepStates.normal">
    <span>Step 6 content</span>
  </ng-wizard-step>

  <ng-wizard-step [title]="'Step 7'" [description]="'Step 7 description'">
    <span>Step 7 content</span>-->
  <!--/ng-wizard-step>-->
  <!--<router-outlet></router-outlet>-->

</ng-wizard>